import { Icons } from "@dnevnik-libs/ui";

import dnevnik_signature from "../assets/dnevnik_signature.png";

export default function ConservationPage() {
  return (
    <div id="wrapper" className="relative flex h-full flex-col overflow-hidden">
      <div id="hat" className="relative flex justify-between">
        <img src={dnevnik_signature} className="absolute top-[-0.25rem] h-14" />
        <div className="mb-2 flex w-full items-center justify-end border-b border-black p-1">
          <small className="text-xs font-medium">
            место для записи событий
          </small>
          <Icons.StarIcon />
        </div>
      </div>
      <div className="flex flex-auto flex-col items-center justify-center gap-6 overflow-scroll p-4">
        <div
          className="flex w-full max-w-[30rem] rotate-[-2deg] flex-col gap-2 bg-white p-4 text-center"
          style={{ boxShadow: "5px 5px 5px rgba(0,0,0,0.25)" }}
        >
          <h4 className="border-b border-black pb-1 font-semibold">
            Увы, эта страница больше не доступна
          </h4>
          <p className="font-medium">Ждём в гости!</p>
        </div>

        <a href="https://dnevnik.bar" className="cursor-pointer">
          <button className="flex items-center justify-between gap-2 border border-black p-2">
            <p>
              перейти на <span className="font-bold">dnevnik.bar</span>
            </p>
            <Icons.ArrowOutward width={20} fill="gray" />
          </button>
        </a>
      </div>
    </div>
  );
}
